export default "__VITE_ASSET__BVbX9Y7F__"